import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface AssetsSummary extends AttributesMixin<typeof AssetsSummary> { }
@define
export class AssetsSummary extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assetsSummary');

    static attributes = {
        invoicesCount: Number,
        paymentsCount: Number,
        creditNotesCount: Number,
        remittanceAdviceCount: Number,
        unappiedCashesCount: Number,
        error: ''
    }
}
